import React, { ChangeEvent, FC, useState } from 'react'
import { InputGroup, Box, Button, Flex } from '@chakra-ui/react'
import CurrencyInput from 'react-currency-input-field'
import theme from '../../styles'
import { Icon } from '../icon'
import { useTranslation } from 'react-i18next'
import { selectScenario, useSelector } from '../../state'
import { ScenarioType } from '../../state/interfaces'

export interface InputCurrencyProps {
  placeholder?: string
  onChange?: (values: string[]) => void
  name: string
}

export const InputCurrency: FC<InputCurrencyProps> = ({ onChange, name }) => {
  const { t } = useTranslation()
  const prefix = '$ '
  const [value, setValue] = useState<string>('')
  const scenario = useSelector(selectScenario)

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    event.preventDefault()
    const inputValue = event.target.value.replace(/[^\d.]/g, '')
    if (!isNaN(Number(inputValue))) {
      setValue(inputValue)
    }
  }

  const handleOnBlur = () => {
    if (value && Number(value) > 0) {
      setValue(Number(value).toFixed(2))
    } else {
      setValue('')
    }
  }

  return (
    <Box spacing={3} marginY={8} width={'full'} maxWidth={350}>
      <InputGroup
        display="grid"
        outline="none"
        borderRadius="md"
        variant="none"
        fontSize={22}
        paddingLeft={4}
        layerStyle={theme.LayerStyles.INPUT}
      >
        <CurrencyInput
          prefix={prefix}
          name={name}
          id="currencyInput"
          data-number-to-fixed="2"
          data-number-stepfactor="100"
          value={value}
          placeholder="$ 0.00"
          onChange={handleChange}
          onBlur={handleOnBlur}
          allowDecimals
          disableAbbreviations
          onClick={(e) => {
            e.stopPropagation()
            e.currentTarget.focus()
          }}
          onKeyPress={(ev) => {
            if (ev.key === 'Enter' && value) {
              ev.preventDefault()
              onChange && onChange([value.toString()])
            }
          }}
          autoFocus
        />
        {value && (
          <Button
            role={'button'}
            position="absolute"
            borderRadius="md"
            layerStyle={theme.LayerStyles.BTN_INPUT_PILL}
            onClick={() => {
              onChange && onChange([value.toString()])
            }}
          >
            <Icon icon="arrow-right" color="white" />
          </Button>
        )}
      </InputGroup>
      {scenario && (scenario.type === ScenarioType.INTERNET_ALERT || scenario.type === ScenarioType.MOBILE_ALERT) && (
        <Flex justifyContent="flex-end">
          <Button
            borderRadius="md"
            onClick={() => {
              onChange && onChange([''])
            }}
            marginTop="0.5em"
            textColor="darkgray"
            fontSize={20}
          >
            {t('common_skip')}
          </Button>
        </Flex>
      )}
    </Box>
  )
}
